"use client";

import { useParams } from "react-router-dom";

import { PageHeader, WorkspacePage } from "@/components/ds/workspace-page";

import { AlertDetailView } from "../components/alert-detail-view";
import { useAlertDetail } from "../hooks";

export function AlertDetailPage() {
  const params = useParams();
  const alertId = typeof params?.alertId === "string" ? params.alertId : "";

  const q = useAlertDetail(alertId, true);

  if (!alertId) {
    return (
      <WorkspacePage className="pt-0">
        <p className="text-caption text-muted">Missing alert id.</p>
      </WorkspacePage>
    );
  }

  return (
    <WorkspacePage className="pt-0">
      <PageHeader
        kicker="Reliability"
        title="Alert detail"
        description="Read-only view of a single alert record and its payload."
      />
      {q.isLoading ? <p className="py-ds-4 text-caption text-muted">Loading…</p> : null}
      {q.isError ? <p className="rounded-control border border-error/30 bg-error/10 px-ds-3 py-ds-2 text-caption text-error" role="alert">Alert not found or failed to load.</p> : null}
      {q.data ? <AlertDetailView alert={q.data} /> : null}
    </WorkspacePage>
  );
}
